module.exports = __webpack_public_path__ + "static/media/3.5d6129cc.jpg";